import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
import JwtService from "@/core/services/JwtService";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: () => import("@/views/layout/MainLayout.vue"),
    meta: {
      middleware: "auth",
    },
    children: [
      {
        path: "",
        name: "home",
        component: () => import("@/views/Home.vue"),
        meta: {
          pageTitle: "首页",
          breadcrumbs: ["首页"],
        },
      },
      {
        path: "/send-message",
        name: "send-message",
        component: () => import("@/views/SendMessages.vue"),
        meta: {
          pageTitle: "发送讯息",
          breadcrumbs: ["发送讯息"],
        },
      },
      {
        path: "/message-templates",
        name: "message-templates",
        component: () => import("@/views/MessageTemplates.vue"),
        meta: {
          pageTitle: "我的文案",
          breadcrumbs: ["我的文案"],
        },
      },
      {
        path: "/message-template/add",
        name: "message-template-add",
        component: () => import("@/views/MessageTemplateAdd.vue"),
        meta: {
          pageTitle: "新增文案",
          breadcrumbs: ["新增文案"],
        },
      },
      {
        path: "/message-tasks",
        name: "message-tasks",
        component: () => import("@/views/MessageTasks.vue"),
        meta: {
          pageTitle: "发送记录",
          breadcrumbs: ["发送记录"],
        },
      },
      {
        path: "/point-transactions",
        name: "point-transactions",
        component: () => import("@/views/PointTransactions.vue"),
        meta: {
          pageTitle: "储值纪录",
          breadcrumbs: ["储值纪录"],
        },
      },
    ],
  },
  {
    path: "/",
    children: [
      {
        path: "/register/:invite_code",
        name: "register",
        component: () => import("@/views/auth/Register.vue"),
        meta: {
          pageTitle: "注册",
        },
      },
      {
        path: "/login",
        name: "login",
        component: () => import("@/views/auth/Password/Index.vue"),
        meta: {
          pageTitle: "登入",
        },
      },
      {
        path: "/set-token/:token",
        name: "set-token",
        component: () => import("@/views/auth/SetToken.vue"),
        meta: {
          pageTitle: "Set Token",
        },
      },
      {
        path: "/news/kyc2025-info",
        name: "news-kyc2025-info",
        component: () => import("@/views/news/KYC2025Info.vue"),
        meta: {
          pageTitle: "短信签名资讯",
        },
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/SystemLayout.vue"),
    children: [
      {
        // the 404 route, when none of the above matches
        path: "/404",
        name: "404",
        component: () => import("@/views/error/Error404.vue"),
        meta: {
          pageTitle: "找不到页面",
        },
      },
      {
        path: "/500",
        name: "500",
        component: () => import("@/views/error/Error500.vue"),
        meta: {
          pageTitle: "系统错误",
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // current page view title
  document.title = `${to.meta.pageTitle} - ${process.env.VUE_APP_NAME}`;

  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  // verify auth token before each page change
  store.dispatch(Actions.VERIFY_AUTH, { token: JwtService.getToken() });

  // before page access check if page requires authentication
  if (to.meta.middleware == "auth") {
    if (store.getters.isUserAuthenticated) {
      next();
    } else {
      next({ name: "login" });
    }
  } else {
    next();
  }

  // Scroll page to top on every route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
});

export default router;
